export default __webpack_public_path__ + "static/boom-e8b6d1101e29b9cb0c7d9230760dd86d.mp3";